import React from 'react';

import BobActionMenu from '../../../../components/BobActionMenu';
import BobTableContextMenu from '../../../../components/BobTableContextMenu';

import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';

import * as classes from './DevicesPanel.module.css';

const DevicesPanel = ({
    deviceObjects,
    selectedAgent,
    ...props
}) => {

    const actionsCell = props => {
        return (
            <td>
                <BobTableContextMenu />
            </td>
        );
    };

    return (
        <div className={classes.DevicesPanel}>
            <div>
                <span className={classes.ActionsButton}>
                    <BobActionMenu />
                </span>
            </div>
            <div className={classes.Table}>
                <Grid
                    className={classes.KendoGrid}
                    data={deviceObjects}
                    total={deviceObjects ? deviceObjects.length : 0}
                >
                    {
                        deviceObjects === null ?
                            <GridNoRecords>
                                Loading devices and objects
                            </GridNoRecords>
                            :
                            null
                    }
                    <Column field="deviceName" title={'Device Name'} width="250px" />
                    <Column field="name" title={'Object Name'} width="auto" />
                    <Column field="profile" title={'Profile'} width="auto" />
                    <Column field="objectType" title={'Type'} width="auto" />
                    <Column field="oBIXPath" title={'OBIX Path'} width="300px" />
                    <Column
                        field=""
                        title=""
                        width="auto"
                        cell={actionsCell}
                    />
                </Grid>
            </div>
        </div>
    );
};

export default DevicesPanel;
